export default __webpack_public_path__ + "static/media/field-foreman.eafb5e63.png";